module.exports = __webpack_public_path__ + "console/img/happy.37ce31e7.png";